import { FetchResult } from '@apollo/client';
import { Form, FormikProvider, useFormik } from 'formik';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { useErrorBoundary } from '@treams/treams-hooks';
import { UpdateApiTokenNotificationEmailMutation } from '@treams/treams-network';
import { Button, GraphQLErrorMessage, Heading3, Input, Paragraph } from '@treams/treams-ui';

type Props = {
	email: string;
	loading: boolean;
	onSubmit: (email: string) => Promise<FetchResult<UpdateApiTokenNotificationEmailMutation>>;
};

const ApiTokenEmailForm: FC<Props> = ({ email, loading, onSubmit }) => {
	const { t } = useTranslation();

	const [error, attempt] = useErrorBoundary();

	const formik = useFormik({
		initialValues: {
			email,
		},
		onSubmit: attempt(async (values) => {
			await onSubmit(values.email);
		}),
	});

	return (
		<FormikProvider value={formik}>
			<GraphQLErrorMessage error={error} showValidationDetails />
			<Form>
				<Flex justifyContent="space-between" alignItems="end">
					<Box flex={5} mr={3} mt={2}>
						<Heading3>{t('apitokens.email')}</Heading3>
						<Paragraph mb={2}>{t('apitokens.userGuide')}</Paragraph>
						<Input.Formik type="email" name="email" />
					</Box>
					<Box flex={1}>
						<Button
							title={t('apitokens.save')}
							loading={loading}
							disabled={formik.values.email.length === 0}
							onClick={() => formik.submitForm()}
							flexGrow={0}
						/>
					</Box>
				</Flex>
			</Form>
		</FormikProvider>
	);
};

export default ApiTokenEmailForm;
